module.exports = __webpack_public_path__ + "static/LGMirrorImage-f02e0463c6ef8e52186f8e014e015d79.jpg";